import { render, staticRenderFns } from "./register-success.vue?vue&type=template&id=7a6b6fe3&scoped=true&"
import script from "./register-success.vue?vue&type=script&lang=js&"
export * from "./register-success.vue?vue&type=script&lang=js&"
import style0 from "./register-success.vue?vue&type=style&index=0&id=7a6b6fe3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6b6fe3",
  null
  
)

export default component.exports